<div class="gm">

  <!-- ==================== Encabezado ==================== -->
  <!-- 29/09/2026: insignia con el icono del módulo, título y frase legibles
       y el botón claro sobre la cabecera, para que se distinga. -->
  <header class="gm-head">
    <span class="material-icons gm-head-ico" aria-hidden="true">policy</span>
    <div class="gm-head-txt">
      <h2>Gestión de Riesgos</h2>
      <p class="gm-sub">
        Las matrices de riesgos de cada área, con el mismo formato y los mismos criterios.
        Toca una para abrirla.
      </p>
    </div>
    <button type="button" class="gm-btn-pri gm-btn-nueva" (click)="nueva()" *ngIf="!borrador && puedeAdministrar">
      <span class="material-icons" aria-hidden="true">add</span>
      Nueva matriz
    </button>
  </header>

  <div class="gm-msg gm-error" *ngIf="error">{{ error }}</div>

  <!-- ==================== Alta ====================
       Solo alta (29/09/2026): una matriz que ya existe se edita desde
       adentro, con el botón Editar de su encabezado. -->
  <div class="gm-alta" *ngIf="borrador">
    <h3>Nueva matriz de riesgos</h3>

    <div class="gm-grid">
      <label class="gm-campo">
        <span>Nombre <b class="oblig">*</b></span>
        <input type="text" class="gm-in" maxlength="50" [(ngModel)]="borrador.nombre"
               placeholder="Ej. Matriz de Riesgos Recursos Humanos">
        <small>Es el nombre con el que aparece en este tablero. Máximo 50 caracteres.</small>
      </label>

      <label class="gm-campo corta">
        <span>Clave del folio <b class="oblig">*</b></span>
        <input type="text" class="gm-in" maxlength="6" [(ngModel)]="borrador.clave" placeholder="RH">
        <small>2 a 6 letras. Sus riesgos se folian <b>RSK-{{ (borrador.clave || 'XX') | uppercase }}-001</b>.</small>
      </label>

      <label class="gm-campo corta">
        <span>Área</span>
        <select class="gm-in" [(ngModel)]="borrador.idCatArea">
          <option [ngValue]="null">Sin área</option>
          <option *ngFor="let a of areas" [ngValue]="a.id">{{ a.area }}</option>
        </select>
      </label>

      <label class="gm-campo">
        <span>Alcance</span>
        <input type="text" class="gm-in" maxlength="200" [(ngModel)]="borrador.alcance"
               placeholder="Qué cubre esta matriz">
      </label>

      <label class="gm-campo">
        <span>Proceso</span>
        <input type="text" class="gm-in" maxlength="200" [(ngModel)]="borrador.proceso">
      </label>

    </div>

    <!-- Las dos preguntas lado a lado, en un renglón (29/09/2026, Norman:
         «acomódalos en una sola línea», sin el blanco que quedaba a la
         derecha). Misma altura; en pantallas angostas se apilan. -->
    <div class="gm-opciones">
      <!-- ===== ¿Trabaja con activos? =====
           Un interruptor (29/09/2026), como el del formato: apagado es No
           (General y Plan de Gestión, lo normal en las áreas); encendido, en
           verde, es Sí (agrega la pestaña de Activos y el expediente por
           activo). Los activos vienen del Inventario de IA. -->
      <div class="gm-carga" [class.on]="borrador.aplicaActivos === 'SI'">
        <div class="gm-carga-cab">
          <span class="material-icons gm-carga-ico" aria-hidden="true">inventory_2</span>
          <div class="gm-carga-txt">
            <strong id="gmConActivos">¿Trabaja con activos?</strong>
            <small *ngIf="borrador.aplicaActivos === 'SI'">
              Encendido: agrega la pestaña de Activos y el expediente por activo. Los activos
              vienen del Inventario de IA.
            </small>
            <small *ngIf="borrador.aplicaActivos !== 'SI'">
              Apagado: sólo General y Plan de Gestión, lo normal en las áreas. Hoy sólo la matriz
              de IA, que lleva Desarrollo, trabaja con activos.
            </small>
          </div>
          <button type="button" class="gm-switch" role="switch"
                  [class.on]="borrador.aplicaActivos === 'SI'"
                  [attr.aria-checked]="borrador.aplicaActivos === 'SI'" aria-labelledby="gmConActivos"
                  [disabled]="leyendoArchivo || guardando" (click)="alternarActivos()">
            <span class="gm-switch-perilla" aria-hidden="true"></span>
          </button>
        </div>
      </div>

      <!-- ===== Cargar el formato FOS-005 ya lleno =====
           Sólo al dar de alta: una matriz que ya existe se edita por su
           pantalla, no volviendo a subir el archivo.
           Es un interruptor (29/09/2026): encendido, en verde, se sube el
           formato; apagado, no se sube nada y la matriz se crea vacía. -->
      <div class="gm-carga" [class.on]="conFormato">
        <div class="gm-carga-cab">
          <span class="material-icons gm-carga-ico" aria-hidden="true">description</span>
          <div class="gm-carga-txt">
            <strong id="gmConFormato">¿Ya tienes el formato FOS-005 lleno?</strong>
            <small *ngIf="conFormato">
              Súbelo y se cargan de una vez su Control de cambios y todos sus riesgos con sus
              cortes de monitoreo. Antes de crear nada te muestro qué encontré, para que lo revises.
            </small>
            <small *ngIf="!conFormato">
              Enciéndelo para subirlo. Apagado, la matriz se crea vacía y sus riesgos se
              capturan desde su pantalla.
            </small>
            <div class="gm-carga-subir" *ngIf="conFormato">
              <label class="gm-btn-sec gm-carga-btn" [class.off]="leyendoArchivo">
                <input type="file" hidden accept=".xlsx"
                       (change)="elegirFormato($event)" [disabled]="leyendoArchivo">
                {{ leyendoArchivo ? 'Leyendo…' : (plan ? 'Cambiar archivo' : '+ Cargar formato FOS-005') }}
              </label>
            </div>
          </div>
          <button type="button" class="gm-switch" role="switch" [class.on]="conFormato"
                  [attr.aria-checked]="conFormato" aria-labelledby="gmConFormato"
                  [disabled]="leyendoArchivo || guardando" (click)="alternarFormato()">
            <span class="gm-switch-perilla" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- ===== Vista previa: lo que se va a crear =====
         En su propio panel y a todo lo ancho (29/09/2026): con las dos
         preguntas lado a lado, sus tablas no cabían en media columna. -->
    <div class="gm-carga gm-carga-previa on" *ngIf="conFormato && plan">
      <div class="gm-previa">

        <div class="gm-previa-cab">
          <span class="gm-previa-archivo">{{ nombreArchivo }}</span>
          <span class="gm-chip" [class.mal]="!plan.valido" [class.ok]="plan.valido">
            {{ plan.valido ? 'Listo para crear' : 'Hay que corregir el archivo' }}
          </span>
        </div>

        <!-- Errores: bloquean. -->
        <div class="gm-msg mal" *ngFor="let e of plan.errores">
          <span class="gm-msg-ico">✕</span><span>{{ e }}</span>
        </div>
        <!-- Avisos: no bloquean, pero hay que verlos. -->
        <div class="gm-msg aviso" *ngFor="let a of plan.avisos">
          <span class="gm-msg-ico">!</span><span>{{ a }}</span>
        </div>
        <!-- Lo que no se va a cargar, dicho en voz alta. -->
        <div class="gm-msg info" *ngFor="let o of plan.omitido">
          <span class="gm-msg-ico">i</span><span>{{ o }}</span>
        </div>

        <ng-container *ngIf="plan.valido">
          <!-- Control de cambios -->
          <div class="gm-seccion">
            <h5>
              Control de cambios
              <span class="gm-n">{{ (plan.versiones || []).length }}</span>
            </h5>
            <div class="gm-tabla-caja">
              <table class="gm-tabla">
                <thead>
                  <tr><th>Versión</th><th>Descripción</th><th>Elaboró</th><th>Autorizó</th><th>Fecha</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let v of plan.versiones">
                    <td class="nw"><b>{{ v.version }}</b></td>
                    <td>{{ v.descripcion }}</td>
                    <td class="nw">{{ v.elaboro || '—' }}</td>
                    <td class="nw">{{ v.autorizo || '—' }}</td>
                    <td class="nw">{{ v.fechaVersion | date: 'dd/MM/yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Plan de gestión -->
          <div class="gm-seccion">
            <h5>
              Plan de Gestión
              <span class="gm-n">{{ (plan.riesgos || []).length }} riesgos</span>
              <span class="gm-n suave">{{ plan.totalCortes }} cortes de monitoreo</span>
            </h5>
            <div class="gm-riesgo" *ngFor="let r of plan.riesgos; let i = index">
              <div class="gm-riesgo-cab">
                <span class="gm-folio">{{ folioPropuesto(i) }}</span>
                <span class="gm-riesgo-desc">{{ r.descripcion }}</span>
                <span class="gm-espacio"></span>
                <span class="gm-sev" [ngClass]="claseSeveridad(severidad(r))">
                  {{ severidad(r) || '—' }}
                </span>
                <span class="gm-n suave">{{ (r.seguimientos || []).length }} cortes</span>
                <span class="gm-n pend" *ngIf="pendientes(r) as p">
                  {{ p }} {{ p === 1 ? 'pendiente' : 'pendientes' }}
                </span>
              </div>
              <div class="gm-riesgo-datos">
                <span *ngIf="r.estrategia"><b>Estrategia:</b> {{ r.estrategia }}</span>
                <span *ngIf="r.periodicidad"><b>Periodicidad:</b> {{ r.periodicidad }}</span>
                <span *ngIf="r.fechaIdentificacion">
                  <b>Identificado:</b> {{ r.fechaIdentificacion | date: 'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
          </div>

          <p class="gm-resumen">
            Se van a crear: <b>1 matriz</b>,
            <b>{{ (plan.versiones || []).length }}</b> versiones del documento y
            <b>{{ (plan.riesgos || []).length }}</b> riesgos con
            <b>{{ plan.totalCortes }}</b> cortes de monitoreo.
            <ng-container *ngIf="totalPendientes as tp">
              <b>{{ tp }}</b> {{ tp === 1 ? 'queda pendiente' : 'quedan pendientes' }} de resultado.
            </ng-container>
            Si algo falla, no se guarda nada.
          </p>
        </ng-container>
      </div>
    </div>

    <div class="gm-alta-pie">
      <button type="button" class="gm-btn-pri" (click)="guardar()"
              [disabled]="guardando || (conFormato && !(plan && plan.valido))"
              [title]="conFormato && plan && plan.valido ? 'Crea la matriz con todo lo del archivo' : ''">
        {{ guardando
            ? 'Creando…'
            : (conFormato ? 'Crear la matriz con el formato' : 'Crear la matriz') }}
      </button>
      <button type="button" class="gm-btn-sec" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      <span class="gm-pie-nota" *ngIf="conFormato && plan && !plan.valido">
        Corrige el archivo y vuelve a subirlo, o apaga el interruptor para crear la matriz vacía.
      </span>
      <span class="gm-pie-nota guia" *ngIf="conFormato && !plan && !leyendoArchivo">
        Sube el formato, o apaga el interruptor para crear la matriz vacía.
      </span>
      <button type="button" class="gm-btn-quitar" *ngIf="conFormato && plan" (click)="quitarFormato()"
              [disabled]="guardando">Quitar el archivo</button>
    </div>
  </div>

  <!-- ==================== Te toca monitorear ====================
       Avisos de monitoreo (29/09/2026, solo en pantalla): lo que vence de
       las matrices en cuya lista estás (se elige en «Editar» de cada
       matriz), desde 5 días antes y mientras siga vencido. -->
  <section class="gm-avisos" *ngIf="!borrador && misAvisos.length" aria-labelledby="gmAvisosTit">
    <header class="gm-avisos-cab">
      <span class="material-icons gm-avisos-ico" aria-hidden="true">notifications_active</span>
      <div>
        <h3 id="gmAvisosTit">Te toca monitorear</h3>
        <p>{{ resumenMisAvisos }}</p>
      </div>
    </header>
    <ul class="gm-avisos-lista">
      <li class="gm-aviso" *ngFor="let a of misAvisos" [class.vencido]="a.proximo.estado === 'VENCIDO'">
        <span class="gm-clave" [style.--gm-area]="colorArea(a.matriz)" [title]="a.matriz.nombre">{{ a.matriz.clave }}</span>
        <span class="gm-aviso-folio">{{ a.item.folio }}</span>
        <span class="gm-aviso-desc" [title]="a.item.descripcion || ''">
          {{ a.item.tipo === 'ACTIVO' ? 'Activo: ' : '' }}{{ a.item.descripcion }}
        </span>
        <span class="gm-aviso-estado" [title]="a.proximo.detalle">{{ a.proximo.texto }}</span>
        <button type="button" class="gm-aviso-ir" (click)="abrir(a.matriz)">
          Abrir
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </button>
      </li>
    </ul>
  </section>

  <!-- ==================== Listado ==================== -->
  <p class="gm-cargando" *ngIf="cargando && !borrador">Consultando las matrices…</p>

  <!-- Cada tarjeta, compacta (29/09/2026: «déjala del tamaño que estaba»):
       clave, nombre y etiquetas en un renglón; área y alcance en uno cada
       uno; las cifras y el folio en línea.
       Y la tarjeta ENTERA abre la matriz (29/09/2026, como las de «Nueva
       solicitud»): sin botones Abrir ni Editar; lo que editaba Editar se
       edita desde adentro de la matriz. En el pie queda «Abrir la matriz →»
       y, a la derecha, dar de baja y eliminar, que se usan poco. -->
  <!-- Mientras se captura una nueva, las tarjetas se ocultan (29/09/2026):
       el formulario queda solo y no se confunde con el listado. -->
  <div class="gm-lista" *ngIf="!cargando && !borrador">
    <article class="gm-card" *ngFor="let m of matrices; trackBy: porId" [class.inactiva]="!activa(m)"
             [style.--gm-area]="colorArea(m)"
             [class.gm-card--abre]="activa(m)"
             [attr.role]="activa(m) ? 'link' : null"
             [attr.tabindex]="activa(m) ? 0 : null"
             [attr.aria-label]="activa(m) ? 'Abrir ' + m.nombre : null"
             (click)="abrir(m)" (keydown.enter)="abrir(m)">
      <header class="gm-card-cab">
        <span class="gm-clave">{{ m.clave }}</span>
        <!-- Nombre y etiquetas juntos: si no caben, las etiquetas bajan
             alineadas bajo el nombre y no bajo la clave. -->
        <div class="gm-card-titulo">
          <h3 class="gm-nombre">{{ m.nombre }}</h3>
          <span class="gm-tag" *ngIf="conActivos(m)">Con activos</span>
          <span class="gm-tag fija" *ngIf="esFija(m)">Matriz base</span>
          <span class="gm-pill-baja" *ngIf="!activa(m)">Dada de baja</span>
        </div>
      </header>

      <div class="gm-card-datos">
        <span class="gm-dato"><b>Área:</b> {{ nombreArea(m) }}</span>
        <span class="gm-dato" *ngIf="m.alcance"><b>Alcance:</b> {{ m.alcance }}</span>
      </div>

      <div class="gm-card-nums">
        <span class="gm-num">
          <b>{{ m.totalRiesgos ?? 0 }}</b>
          {{ (m.totalRiesgos ?? 0) === 1 ? 'riesgo de proceso' : 'riesgos de proceso' }}
        </span>
        <span class="gm-num" *ngIf="conActivos(m)">
          <b>{{ m.totalActivos ?? 0 }}</b>
          {{ (m.totalActivos ?? 0) === 1 ? 'activo' : 'activos' }}
        </span>
        <span class="gm-num gm-num--folio">Folios <b>RSK-{{ m.clave }}-001…</b></span>
      </div>

      <!-- Avisos de monitoreo de la matriz (29/09/2026): los ve cualquiera
           que abra el tablero; «Te toca monitorear», solo los de su lista. -->
      <div class="gm-card-avisos" *ngIf="activa(m) && conteo(m) as c">
        <span class="gm-av gm-av--vencido" *ngIf="c.vencidos">
          {{ c.vencidos }} {{ c.vencidos === 1 ? 'monitoreo vencido' : 'monitoreos vencidos' }}
        </span>
        <span class="gm-av gm-av--pronto" *ngIf="c.porVencer">
          {{ c.porVencer }} por vencer
        </span>
      </div>

      <!-- Los dos botones de icono paran el clic: sin eso, dar de baja o
           eliminar abría además la matriz. -->
      <footer class="gm-card-acc">
        <span class="gm-card-ir" *ngIf="activa(m)">
          Abrir la matriz
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </span>
        <span class="gm-card-ir gm-card-ir--off" *ngIf="!activa(m)">Reactívala para abrirla</span>
        <span class="gm-espacio"></span>
        <!-- Activa / De baja (29/09/2026, «que se vea el efecto»): el
             interruptor dice el estado de hoy con su palabra, verde si está
             activa y gris si está dada de baja, y se corre al confirmar.
             Solo para quien administra el tablero. -->
        <button type="button" class="gm-estado" role="switch" *ngIf="!esFija(m) && puedeAdministrar"
                [class.on]="activa(m)" [attr.aria-checked]="activa(m)"
                [disabled]="cambiandoEstatus === m.idMatriz"
                (click)="$event.stopPropagation(); alternarEstatus(m)"
                (keydown.enter)="$event.stopPropagation()"
                [matTooltip]="activa(m) ? 'Dar de baja' : 'Reactivar'"
                matTooltipPosition="above" matTooltipClass="gm-tip"
                [attr.aria-label]="activa(m) ? 'Activa. Dar de baja' : 'Dada de baja. Reactivar'">
          <span class="gm-estado-et">{{ activa(m) ? 'Activa' : 'De baja' }}</span>
          <span class="gm-switch gm-switch--mini" [class.on]="activa(m)" aria-hidden="true">
            <span class="gm-switch-perilla"></span>
          </span>
        </button>
        <button type="button" class="gm-btn-rojo mini gm-btn-ico" *ngIf="!esFija(m) && puedeAdministrar"
                (click)="$event.stopPropagation(); eliminar(m)"
                (keydown.enter)="$event.stopPropagation()"
                matTooltip="Eliminar" matTooltipPosition="above" matTooltipClass="gm-tip"
                aria-label="Eliminar">
          <span class="material-icons" aria-hidden="true">delete_outline</span>
        </button>
      </footer>
    </article>

    <p class="gm-vacio" *ngIf="matrices.length === 0">
      Todavía no hay matrices.<ng-container *ngIf="puedeAdministrar"> Crea la primera con <b>Nueva matriz</b>.</ng-container>
    </p>
  </div>
</div>
